<template>
    <div class="main-container">

        <router-view></router-view>
        <!-- Navbar section -->
        <HeaderElement />

        <!-- breadcrumb strat -->
        <Breadcrumb>
            <template slot="breadcrumb">
                <div class="breadcrumb_box text-center">
                    <h2 class="breadcrumb-title">Team Member</h2>
                    <!-- breadcrumb-list start -->
                    <ul class="breadcrumb-list">
                        <li class="breadcrumb-item"><router-link :to="{name:'HomeBranding'}">Home</router-link></li>
                        <li class="breadcrumb-item"><router-link :to="{name:'HomeBranding'}">Elements</router-link></li>
                        <li class="breadcrumb-item active">Team Member</li>
                    </ul>
                    <!-- breadcrumb-list end -->
                </div>
            </template>
        </Breadcrumb>
        <!-- breadcrumb end -->

        <!-- team one start -->
        <TeamOne />
        <!-- team one end -->

        <!-- team member two start -->
        <div class="team-member-wrapper section-space--ptb_120 default-bg">
            <div class="container">
                <TeamTwo />
            </div>
        </div>
        <!-- team member two end -->

        <!-- footer section -->
        <FooterMain />

        <!-- offcanvas search component -->
        <OffcanvasSearchBox />

        <!-- off-canvas mobile menu -->
        <OffCanvasMobileMenu />

    </div>
</template>

<script>
    import HeaderElement from '@/components/HeaderElement'
    import Breadcrumb from '@/components/Breadcrumb'
    import TeamOne from '@/components/TeamOne'
    import TeamTwo from '@/components/TeamTwo'
    import FooterMain from '@/components/FooterMain'
    import OffcanvasSearchBox from '@/components/OffcanvasSearchBox'
    import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'

    export default {
        name: 'ElementTeamMember',
        components: {
            HeaderElement,
            Breadcrumb,
            TeamOne,
            TeamTwo,
            FooterMain,
            OffcanvasSearchBox,
            OffCanvasMobileMenu
        },

        metaInfo: {
            title: 'CREIS Japan - Element Team Member',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        }
    }
</script>

